<template>
    <div id="wrapper">
        <Sidebar :mobile="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <Topbar />
                <MobileMenu :activePage="'All Members'" />
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="akkurate-green">All Members</h4>
                        </div>
                        <hr />

                        <div>
                            <!-- Search bar -->
                            <b-form @submit.prevent="filterTable()" class="d-flex justify-content-between align-items-center py-2 col-12 mb-3">
                                <div class="col-10">
                                    <b-form-group id="search" label-for="search" class=" position-relative">
                                        <b-form-input id="search" type="text" style="background-color: #E8EDF0;" class="form-control form-control-lg rounded-pill ps-3 pe-4" placeholder="Search by name, phone number, email, staff ID" v-model="form.search_term" />
                                        <button v-if="form.search_term" class="btn position-absolute end-0 translate-middle-y akkurate-danger-bg text-white" style="right: 5px !important; top: 3px !important; transform: scale(0.5) !important; border-radius: 20px !important;" @click="form.search_term = ''">
                                            <font-awesome-icon :icon="['fas', 'close']" class="text-white" />
                                        </button>
                                    </b-form-group>
                                </div>
                                <div class="col-1">
                                    <b-button type="submit" :disabled="isSearching" class="fw-semibold akkurate-auth-size akkurate-green-btn">
                                        <span class="small"><font-awesome-icon :icon="['fas', 'search']" /></span>
                                    </b-button>
                                </div>
                            </b-form>

                            <!-- Member card -->

                            <div class="text-center text-danger my-2" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>

                            <div class="container-fluid px-0 akkurate-small" v-else>
                                <div class="card d-flex w-100 justify-content-center p-0 shadow-sm mb-3" v-for="item in this.items">
                                    <div class="my-card mb-0">
                                        <!-- Profile Picture -->
                                        <div class="image" style="width: 80px !important; height: 80px !important;">
                                            <img id="profile-picture" :src="item.passport_pic_path" alt="Profile" style="width: 80px !important; height: 80px !important;" @error="setDefaultImage($event)" />
                                        </div>


                                        <!-- User Info -->
                                        <div class="card-info">
                                            <h5>{{ item.first_name }} {{ item.last_name }}</h5>
                                            <p>{{ item.code }}</p>
                                            <p><span class="fw-bold me-2">{{ item.gender }}</span> {{ item.mobile }}</p>
                                            <p class="d-flex align-items-center mb-0">
                                                <span class="fw-bold p-0  me-2">{{ item.branch?.name }}</span>
                                                <span :class="statusBadge(item.status)">{{ item.status }}</span>
                                            </p>
                                        </div>

                                        <!-- Action Dropdown -->
                                        <div class="dots-icon top-0 end-0">
                                            <b-dropdown right boundary="viewport" variant="link" no-caret toggle-class="text-dark p-0">
                                                <template #button-content>
                                                    <i class="fas fa-ellipsis-v fa-lg"></i>
                                                </template>
                                                <b-list-group flush>
                                                    <!-- Deposit -->
                                                    <b-list-group-item class="d-flex align-items-center gap-3 px-3 py-2 rounded custom-pointer" @click="openPopup('Deposit', item.id)">
                                                        <div class="text-dark me-2">
                                                            <i class="fas fa-arrow-up fa-lg"></i>
                                                        </div>
                                                        <span class="fw-bold text-dark text-truncate">Deposit</span>
                                                    </b-list-group-item>

                                                    <!-- Withdraw -->
                                                    <b-list-group-item class="d-flex align-items-center gap-3 px-3 py-2 rounded bg-light custom-pointer" @click="openPopup('Withdraw', item.id)">
                                                        <div class="text-dark me-2">
                                                            <i class="fas fa-arrow-down fa-lg"></i>
                                                        </div>
                                                        <span class="fw-bold text-dark text-truncate">Withdraw</span>
                                                    </b-list-group-item>

                                                    <!-- Loan Repayment -->
                                                    <b-list-group-item class="d-flex align-items-center gap-3 px-3 py-2 rounded custom-pointer" @click="openPopup('loan', item.id)">
                                                        <div class="text-dark me-2">
                                                            <!-- <i class="fas fa-coins fa-lg"></i> -->
                                                            <i class="fas fa-hand-holding-usd fa-lg"></i>
                                                        </div>
                                                        <span class="fw-bold text-dark text-truncate">Loan Repayment</span>
                                                    </b-list-group-item>
                                                </b-list-group>

                                            </b-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="d-flex flex-column align-items-center pt-1 px-2 pb-3">
                                <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="loan-table"></b-pagination>

                                <div class="d-flex gap-3 align-items-center mt-1">
                                    <div>
                                        {{ currentPage }} - {{ perPage }} of
                                        {{ totalRecords }}
                                    </div>
                                    <b-form-group label="Per Page" label-size="sm" class="mb-0 d-flex align-items-center" style="margin-top: 0.5rem;">
                                        <b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Popup Modal -->
                <b-modal id="account-select-modal" ref="accountModal" centered hide-footer>
                    <template #modal-title>
                        <span class="fw-bold akkurate-small">{{ popupTitle }}</span>
                    </template>

                    <div>
                        <div class="text-center text-danger my-2" v-if="isLoading">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>

                        <div class="col mb-2 mb-md-0" v-else>
                            <multiselect v-model="selectedOption" :options="popUpOptions" label="text" track-by="value" placeholder="Select account" class="mt-2 field-container" />
                        </div>

                        <div class="d-flex justify-content-center gap-2 mt-3 mb-2">
                            <b-button @click="$refs.accountModal.hide()" class="btn btn-size fw-semibold">Cancel</b-button>
                            <b-button class="btn btn-size fw-semibold akkurate-green-btn" :disabled="isLoading" @click="confirmAction">Proceed</b-button>
                        </div>
                    </div>
                </b-modal>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
        <!-- <cash-deposit ref="showCashDeposit" :report_data="report_data"></cash-deposit> -->
        <!-- <mobile-receipt ref="showMobileReceipt" :report_data="report_data"></mobile-receipt> -->
    </div>
</template>
<script>
import Topbar from "@/views/main/components/Topbar.vue";
import Sidebar from "@/views/main/components/Sidebar.vue";
import MobileMenu from "../../../components/MobileMenu.vue";
// import CashDeposit from "../reports/cash/CashDeposit.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import MobileReceipt from "./print/MobileReceipt.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";


export default {
    components: {
        MobileMenu,
        Topbar,
        Sidebar,
        // CashDeposit,
        Multiselect,
        MobileReceipt,
        ChatBot,
    },
    data() {
        return {
            isLoading: false,
            selectedAction: null,
            selectedOption: null,
            selectedMember: {},
            popUpOptions: [],
            isSearching: false,
            digitalAddress: "",
            popupTitle: "",
            status_option: ['Pending', 'Active', 'Inactive', "Dormant", "Closed"],
            trans_source_options: [
                { name: 'USSD', value: "ussd" },
                { name: 'OFFICE', value: "office" },
                { name: 'MOBILE', value: "mobile" },
                // { name: 'Deposit', value: "deposit" },
                // { name: 'Withdrawal', value: "withdrawal" },
            ],
            selected: 'custom',
            options: [
                { text: 'Custom', value: 'custom' },
                { text: 'Bulk', value: 'bulk' }
            ],
            recipient: "",
            message: "",
            sms_message: "",
            users_options: [],
            member_id: "",
            selectedCustomerNumber: "",
            institution: {},
            totalRecords: 0,
            searchFilter: "",
            isBusy: true,
            branch: null,
            branch_option: [],
            currentPage: 1,
            perPage: 10,
            per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
            per_page_selected: "10",
            disable_recipient: false,
            form: {
                status: "",
                search_term: "",
                from_date: "",
                to_date: "",
                trans_source: "",
                branch: "",
                start_date: "",
                end_date: "",
                gender: "",
                gender_option: ['Male', 'Female', 'Group'],
                users: []
            },
            items: []
        };
    },
    mounted() {
        let token = localStorage.getItem('token');
        if (!token) {
            this.$router.push({ path: '/login' });
        }

        this.getAccountDropdown();
        this.loadItems();
        this.getInsistution();
    },
    computed: {

    },
    methods: {
        setDefaultImage(event) {
            event.target.src = require('@/assets/img/Ghana-Card-Front.png'); // or a public path like '/images/default.png'
        },
        openPopup(action, id) {
            this.selectedAction = action
            this.selectedOption = null
            this.$refs.accountModal.show()
            this.getMember(id, action)

            this.popupTitle = action.toLowerCase() === "loan" ? "Select Loan" : "Select Account"

        },
        setPopUpOptions(type) {
            this.popUpOptions = []

            // console.log("Selected Member", this.selectedMember)
            if (type === "loan") {
                this.selectedMember?.accounts?.forEach(acc => {
                    if (acc?.loan) {
                        this.popUpOptions.push({
                            value: acc.loan.loan_number,
                            text: `${acc.loan.loan_number} ~ ${acc.loan.loan_product?.name}`
                        })
                    }
                })
            } else {
                this.selectedMember?.accounts?.forEach(acc => {
                    this.popUpOptions.push({
                        value: acc.account_number,
                        text: `${acc.account_type?.name.charAt(0).toUpperCase()}${acc.account_type?.name.slice(1)} Account - ${acc.account_number}`
                    })
                })

            }
        },
        confirmAction() {
            if (!this.selectedOption) {
                this.$bvToast.toast("Please select an account", {
                    title: "Validation Error",
                    variant: "danger",
                    solid: true,
                });
                return;
            }

            const action = this.selectedAction.toLowerCase();

            if (action === "withdraw") {
                this.$router.push({
                    path: `/mobile/withdrawal`,
                    query: {
                        account_number: this.selectedOption.value,
                    }
                });
            } else if (action === "deposit") {
                this.$router.push({
                    path: `/mobile/deposit`,
                    query: {
                        account_number: this.selectedOption.value,
                    }
                });
            } else if (action === "loan") {
                this.$router.push({
                    path: `/mobile/loan-repayment`,
                    query: {
                        loan_number: this.selectedOption.value,
                    }
                });
            }

            this.$refs.accountModal.hide();
        }
        ,
        async getAccountDropdown() {
            this.$Progress.start();
            this.isBusy = true;
            await ApiService.get("/accounts/create/dropdown")
                .then((response) => {
                    // console.log(response);
                    this.form.branch_option = response?.data?.branches
                    this.form.acc_types_option = response?.data?.account_types
                    this.users_options = response?.data?.users
                    this.isBusy = false;
                    this.$Progress.finish();
                }).catch((error) => {
                    // console.log(error);
                })
        },
        filterTable() {
            this.loadItems();
        },
        optionLabel({ text }) {
            let name = "";
            if (text) {
                name = name + text;
            }

            return `${name}`;
        },
        // load items is what brings back the rows from server
        async loadItems() {
            this.isBusy = true;
            this.$Progress.start();  // Start the progress bar
            // console.log(this.form.users);
            await ApiService.post("customers/paginate",
                {
                    "page": this.currentPage,
                    "per_page": this.perPage,
                    "filter": this.form.search_term,
                    "branch_id": this.form.branch?.id,
                    "status": this.form.status, //Inactive,	Active, Inactive, Dormant, Closed
                    "source": this.form.trans_source,
                    "start_date": this.form.start_date,
                    "end_date": this.form.end_date,
                    "region_id": null,
                    "gender": this.form.gender,
                    'users': this.form.users.map(index => index.id)
                }).then(response => {
                    // Handle response and update table data
                    this.isBusy = false;  // Set isBusy to false when the data is loaded
                    this.$Progress.finish();  // Finish the progress bar
                    this.items = response.data.data;
                    // console.log("Members: ", this.items)
                    this.totalRecords = response.data.meta.total;

                }).catch(() => {
                    this.isBusy = false;  // Set isBusy to false in case of an error
                    this.$Progress.finish();  // Finish the progress bar even if there's an error
                    return [];  // Return an empty array in case of error to prevent the table from breaking
                }).finally(() => {
                    this.isBusy = false;  // Set isBusy to false in case of an error
                    this.$Progress.finish();  // Finish the progress bar even if there's an error
                });
        },

        async getMember(memberId, str) {
            this.isLoading = true;
            await ApiService.get("/customers/view/" + memberId)
                .then((response) => {
                    this.selectedMember = response.data.data;
                    this.isLoading = false;

                    this.setPopUpOptions(str);
                })
                .catch((error) => {
                    this.isLoading = false;
                    swal.fire({
                        // title: response.statusText,
                        text: error.response.data.message,
                        icon: "error",
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                        showCancelButton: false, // Show the "Cancel" button
                        confirmButtonText: "okay", // Customize the text for the "OK" button
                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                        customClass: {
                            confirmButton:
                                "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        },
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                    // this.isLoading = false
                });
        },
        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        mobileToggle() {
            this.mobile_menu = !this.mobile_menu;
        },
        handleImageLoad() {
            // console.log(this.form?.gh_card_front_path);
            if (this.form?.gh_card_front_path) {
                this.imageLoaded = true;
                this.frontImgUrl = this.form?.gh_card_front_path;
            }
            if (this.form?.gh_card_back_path) {
                this.imageLoaded = true;
                this.backImgUrl = this.form?.gh_card_back_path;
            }

            // console.log("front ", this.frontImgUrl)
            // console.log("Back ", this.backImgUrl)
        },
        navigatePage(index) {
            this.isBusy = true;
            this.currentPage = index;
            this.loadItems()
        },
        selectPerPage(index) {
            this.perPage = index
            this.loadItems()
        },
        clearForm() {
            this.form = this.initialState().form; // Call the initialState method to get the default form
        },
        statusBadge(status) {
            // console.log(status === 'Active');
            if (status === 'Active') {
                return 'badge akkurate-green-bg'
            } else if (status === 'Inactive') {
                return 'badge akkurate-danger-bg'
            } else if (status === 'Dormant') {
                return 'badge akkurate-danger-bg'
            } else if (status === 'Pending') {
                return 'badge akkurate-warning-bg'
            } else {
                return 'badge akkurate-warning-bg'
            }
        }
    },
};
</script>

<style scoped>
.input-group>.custom-group {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}

.icon_color {
    color: #c1c2c4;
}

.my-card {
    display: flex;
    overflow: hidden;
    align-items: center;
    padding: 0 !important;
}

.card {
    padding: 0.6rem !important;
    border-radius: 8px !important;
}

.my-card .image {
    width: 80px !important;
    height: 80px !important;
    border-radius: 100px;
    margin-right: 0.5rem;
}

.my-card .image img {
    width: 100%;
    height: 100%;
    border-radius: 20px;
    object-fit: cover;
}

.card-info {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
}

.card-info h5,
.card-info p {
    padding: 0;
    margin: 0;
}

.card-info h5 {
    font-size: 1.1rem !important;
    font-weight: 700;
    text-wrap: wrap;
}

.card-info p {
    color: #555555;
    padding: 0;
    margin: 0;
}

.dots-icon {
    box-shadow: none !important;
}
</style>
